import React from 'react';
import PropTypes from 'prop-types';
import { Box,  Typography, useTheme } from '@mui/material';
import { EVENTS } from '../../../constants';
import { useCurrentUser } from '../../../context/UserContext';
import RSVPSignUp from './RSVPSignUp';
import RSVPYesIcon from '../../Icons/RSVPYes';
import RSVPMaybeIcon from '../../Icons/RSVPMaybe';
import RSVPNoIcon from '../../Icons/RSVPNo';

const styles = {
  main: {
    backgroundColor: (theme) => theme.palette.primary.main,
    padding: '35px 22px',
    textAlign: 'center',
  },
  icon: {
    margin: '12px 0',
    stroke: (theme) => theme.palette.secondary.main,
    fill: 'none',
    fontSize: '50px',
  },
  button: {
    alignItems: 'center',
    backgroundColor: (theme) => theme.palette.secondary.main,
    color: (theme) => theme.palette.primary.main,
    display: 'flex',
    height: '40px',
    justifyContent: 'center',
    marginTop: '20px',
    textDecoration: 'none !important',
    width: '100%',
  },
}

export default function RSVPConfirmation({ data }) {
  
  const theme = useTheme();
  const { user } = useCurrentUser();

  let title = '';
  const subtitle = data.isUpdate
    ? 'Thanks for keeping us updated!'
    : 'Thanks for the RSVP.';
  let Icon = null;
  switch (data.status) {
    case EVENTS.STATUS.YES:
      Icon = RSVPYesIcon;
      title = "Great! Can't wait to see you there.";
      break;
    case EVENTS.STATUS.MAYBE:
      Icon = RSVPMaybeIcon;
      title = 'Let us know when you decide.';
      break;
    case EVENTS.STATUS.NO:
      Icon = RSVPNoIcon;
      title = "We're sorry you can't make it.";
      break;
    default:
      break;
  }
  return (
    <Box>
      <Box sx={styles.main}>
        {Icon && <Icon sx={styles.icon} />}
        <Typography
          style={{ color: theme.palette.secondary.main }}
          variant="h3"
        >
          {title}
        </Typography>
        <Typography
          style={{ color: theme.palette.secondary.main }}
          variant="body1"
        >
          {subtitle}
        </Typography>
      </Box>
      {!user?.handle && <RSVPSignUp />}
    </Box>
  );
}

RSVPConfirmation.propTypes = {
  data: PropTypes.shape({
    status: PropTypes.oneOf(Object.values(EVENTS.STATUS)),
    isUpdate: PropTypes.bool,
    eventId: PropTypes.string,
  }),
};
